import { money } from "@/lib/api";

export const KpiStrip = ({ kpis }) => {
  const items = [
    ["Bank cash", money(kpis.cash), "kpi-cash", "text-white"],
    ["Stripe MRR", money(kpis.mrr), "kpi-mrr", "text-[#00FF9D]"],
    ["Monthly burn", money(kpis.burn), "kpi-burn", "text-white"],
    ["Net burn", money(kpis.net_burn), "kpi-net-burn", kpis.net_burn > 0 ? "text-[#FF5C7A]" : "text-[#00FF9D]"],
    ["QBO A/R", money(kpis.ar), "kpi-ar", "text-white"],
    ["QBO A/P", money(kpis.ap), "kpi-ap", "text-white"],
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 border-t border-l border-[#2A2A2A] rounded-xl overflow-hidden">
      {items.map(([label, val, tid, color], i) => (
        <div key={tid} className="p-5 border-r border-b border-[#2A2A2A] bg-[#0B0B0B] fade-up" style={{ animationDelay: `${i * 60}ms` }}>
          <p className="text-[11px] uppercase tracking-wider text-[#A3A3A3]">{label}</p>
          <p data-testid={tid} className={`font-mono text-xl md:text-2xl font-bold mt-2 ${color}`}>{val}</p>
        </div>
      ))}
    </div>
  );
};
